import React from 'react';
import { Box, Tabs, Button } from 'lmc-ui-library';
import Admin from './Admin';
import { FirmAdminsProps } from './types';
import { AdminType } from '../types';
import { TabConfig } from 'shared/interface/globalInterface';
import { Link } from 'react-router-dom';

import styles from '../profile.module.scss';

const FirmAdmins: React.FC<FirmAdminsProps> = ({ title, isClub, admins, onChangeClick, setFieldValue, firmId }) => {
  const createConfig = (adms: AdminType[]) => {
    const config: TabConfig[] = [];

    adms.forEach((adm) => {
      config.push({ label: adm.firstName, id: adm.id });
    });

    return config;
  };

  const config = createConfig(admins);

  return title === 'Firm Admins' ? (
    <Box title={title} className={styles.box}>
      <Box.Content>
        <Button as={Link} to={`/bp/firm/${firmId}/managers`} mode="secondary" borderVariant="rectangle">
          Show Users
        </Button>
      </Box.Content>
    </Box>
  ) : (
    <Box title={title} className={styles.box}>
      <Box.Content>
        <Tabs config={config}>
          {admins.map((admin, index) => (
            <Admin
              key={`${admin.id}.${index}`}
              index={index}
              onChangeClick={onChangeClick(admin.id)}
              addressValues={admin.address}
              setFieldValue={setFieldValue}
              isClub={isClub}
            />
          ))}
        </Tabs>
      </Box.Content>
    </Box>
  );
};

export default FirmAdmins;
